"use client"
import React from "react";
import "./VacancyHero.scss";
import {toggleSendCVModal} from "@/helpers/toggleModals";
const VacancyHero = ({ name }) => {
  return (
    <section className="vacancy-hero">
      <h2 className="vacancy-hero__subtitle">vacancy</h2>
      <h1 className="vacancy-hero__title">{name}</h1>
      <button onClick={toggleSendCVModal} className="button vacancy-hero__btn ">Apply now</button>
    </section>
  );
};

export default VacancyHero;
